export default {
	title: '巡检机构',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	table: {
		id: 'ID',
		name: '名称',
		location: '位置信息',
		icon: '图标'
	},
	buttons: {
		expandAll: '全部展开',
		collapseAll: '全部收起',
		add: '新增',
		edit: '修改',
		delete: '删除'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		superiorDepartment: '上级部门',
		name: '名称',
		location: '位置信息',
		icon: '图标',
		leader: '负责人',
		sort: '排序',
		logoPicture: 'Logo 图片',
		aiAssistantEnabled: 'AI 助手开启',
		gridLayout: '格栅布局',
		sensorStatusChangeNotify: '测点状态变更通知',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			superiorDepartment: '请选择上级部门',
			name: '请输入名称',
			location: '请输入位置信息',
			icon: '请选择图标',
			leader: '请选择负责人',
			sort: '请输入排序',
			aiAssistantEnabled: '请选择是否开启',
			sensorStatusChangeNotify: '测点状态变更通知'
		},
		options: {
			aiAssistantStatus: {
				closed: '关闭',
				enabled: '开启'
			},
			notifyStatus: {
				offline: '离线通知',
				abnormal: '异常通知',
				all: '都通知',
				none: '都不通知'
			}
		}
	}
}
